import React from "react";
import Layout from "../../components/Layout/Layout";
import { Helmet } from "react-helmet";

export default function TermsConditions() {
  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>
          MyBilty - Manage Bilty and Lorry Receipt - Truck Bilty Software
        </title>
        <meta
          name="description"
          content="Generate bilty or lorry receipt online with MyBilty and manage your transport documents and accounts at one place. Download MyBilty - trusted bilty software."
        />
        <meta
          name="keywords"
          content="MyBilty, bilty, online lr, transport bilty, lorry receipt, bilty transport, lr online, bilty in transport, transport bilty software, bilty software, lr in transport, truck bilty"
        />
        <meta name="author" content="MyBilty" />
        <meta name="copyright" content="Owner" />
        <meta name="robots" content="index, follow" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="MyBilty - Manage Bilty and Lorry Receipt - Truck Bilty Software"
        />
        <meta property="og:url" content="https://mybilty.com/" />
        <meta property="og:image" content="" />
        <meta
          property="og:description"
          content="Generate bilty or lorry receipt online with MyBilty and manage your transport documents and accounts at one place. Download MyBilty - trusted bilty software."
        />
        <link rel="canonical" href="https://mybilty.com/" />
      </Helmet>
      <Layout>
        <>
          <div className="bred_crumb blog_detail_bredcrumb">
            <div className="container">
              <div className="bred_text">
                <h1>Terms &amp; Conditions</h1>
              </div>
            </div>
          </div>
          <section className="blog_detail_section">
            <div className="container">
              <div className="blog_inner_pannel">
                <div className="review">
                  <span>Last Updated: </span>
                  <span>12 December, 2024</span>
                </div>
                <div className="section_title">
                  <h2>Introduction</h2>
                </div>
                <div className="container">
                  <p>
                    <strong />
                  </p>
                  <h2>Welcome to MyBilty!</h2>
                  <p>
                    These Terms and Conditions govern your use of MyBilty,
                    including the web platform, mobile applications, and
                    services provided by MyBilty. By accessing or using our
                    platform, you agree to be bound by these terms. Please read
                    them carefully.
                  </p>
                  <p>
                    If you do not agree to any part of these Terms and
                    Conditions, you must discontinue using our platform and
                    services immediately.
                  </p>
                  <h2>1. Definitions</h2>
                  <ul>
                    <li>
                      <strong>Platform:</strong> Refers to the MyBilty system,
                      including the web portal and mobile applications
                      (Transporter Admin App and Driver App).
                    </li>
                    <li>
                      <strong>We, Us, Our:</strong> Refers to MyBilty Tech, the
                      service provider and operator of the MyBilty platform.
                    </li>
                    <li>
                      <strong>User, You, Your:</strong> Refers to anyone
                      accessing or using the platform, including Super Admin,
                      Transporter Admin, Drivers, and other authorized
                      personnel.
                    </li>
                    <li>
                      <strong>Subscription:</strong> Refers to paid plans for
                      accessing specific features of the MyBilty platform.
                    </li>
                    <li>
                      <strong>Free Trial:</strong> Refers to the initial 30 days
                      trial access with limited functionalities.
                    </li>
                  </ul>
                  <h2>2. Acceptance of Terms</h2>
                  <ul>
                    <li>
                      You confirm that you are at least eighteen years of age.
                    </li>
                    <li>
                      You can bind yourself or your organization to these Terms
                      and Conditions.
                    </li>
                    <li>
                      You agree to comply with all terms stated herein and
                      applicable local, national, and international laws.
                    </li>
                  </ul>
                  <h2>3. User Roles and Responsibilities</h2>
                  <h3>3.1 Super Admin</h3>
                  <ul>
                    <li>Full access to all platform functionalities.</li>
                    <li>
                      Responsible for creating and managing subscription plans.
                    </li>
                    <li>
                      Monitors transactions and generates system-wide reports.
                    </li>
                    <li>Handles user support tickets and platform settings.</li>
                  </ul>
                  <h3>3.2 Transporter Admin</h3>
                  <ul>
                    <li>Manages transporter-specific operations, including:</li>
                    <ul>
                      <li>Bilty/lorry receipt management.</li>
                      <li>
                        Master data (party, vehicle, driver, and material
                        details).
                      </li>
                      <li>
                        Financial accounts, including invoices, loading slips,
                        and ledgers.
                      </li>
                    </ul>
                  </ul>
                  <h3>3.3 Drivers</h3>
                  <ul>
                    <li>
                      Limited access to the Driver App for tasks, including:
                    </li>
                    <ul>
                      <li>
                        Updating assignments (loading, bilty, deliveries).
                      </li>
                      <li>
                        Uploading delivery documents and reporting issues.
                      </li>
                      <li>GPS navigation and real-time updates.</li>
                    </ul>
                  </ul>
                  <h2>4. Account Registration</h2>
                  <ul>
                    <li>
                      Users must provide accurate, complete, and updated
                      registration details, including valid contact and identity
                      information.
                    </li>
                    <li>
                      You are responsible for maintaining the confidentiality of
                      your login credentials.
                    </li>
                    <li>
                      Notify us immediately if you suspect any unauthorized
                      access or misuse of your account.
                    </li>
                  </ul>
                  <h2>5. Subscription Plans and Payments</h2>
                  <h3>5.1 Free Trial</h3>
                  <p>
                    New users are eligible for a 30 days free trial with limited
                    functionalities. Access will be restricted at the end of the
                    trial unless you subscribe to a paid plan.
                  </p>
                  <h3>5.2 Subscription Plans</h3>
                  <ul>
                    <li>
                      Plan Options: Monthly and yearly subscription plans based
                      on:
                    </li>
                    <ul>
                      <li>Feature sets</li>
                      <li>Number of bilty/lorry receipts created</li>
                    </ul>
                    <li>
                      Payments must be made via our integrated payment gateway.
                    </li>
                    <li>
                      Subscriptions will auto-renew unless canceled before the
                      renewal date.
                    </li>
                  </ul>
                  <h3>5.3 Late or Failed Payments</h3>
                  <ul>
                    <li>
                      Non-payment or failed transactions may result in account
                      suspension or access restriction.
                    </li>
                    <li>Users will be notified before any such action.</li>
                  </ul>
                  <h2>6. Platform Usage</h2>
                  <h3>6.1 Permitted Use</h3>
                  <ul>
                    <li>
                      You agree to use the platform only for legal and
                      authorized purposes related to transportation management.
                    </li>
                    <li>
                      Accurate and up-to-date information must be entered for
                      all platform functionalities, including bilty/lorry
                      receipts, invoices, and financial records.
                    </li>
                  </ul>
                  <h3>6.2 Prohibited Use</h3>
                  <ul>
                    <li>
                      Use the platform for fraudulent, illegal, or unauthorized
                      purposes.
                    </li>
                    <li>
                      Share login credentials or unauthorized access with third
                      parties.
                    </li>
                    <li>
                      Modify, reverse-engineer, or attempt to hack the platform.
                    </li>
                    <li>
                      Upload harmful content, including malware, viruses, or
                      illegal materials.
                    </li>
                  </ul>
                  <h2>7. Data Management and Security</h2>
                  <p>
                    We implement strict security measures to protect user data.
                    While we take reasonable precautions, we cannot guarantee
                    complete protection against data breaches.
                  </p>
                  <h2>8. Service Availability and Maintenance</h2>
                  <p>
                    Services may occasionally be unavailable due to maintenance,
                    updates, or unforeseen issues. We are not liable for any
                    loss or inconvenience caused by downtime.
                  </p>
                  <h2>9. Termination of Access</h2>
                  <ul>
                    <li>
                      You may terminate your account at any time by contacting
                      our support team.
                    </li>
                    <li>
                      We reserve the right to suspend or terminate your account
                      if you violate these Terms or fail to complete
                      subscription payments.
                    </li>
                  </ul>
                  <h2>10. Intellectual Property</h2>
                  <p>
                    All intellectual property, including trademarks, software
                    code, platform designs, and content, is owned by MyBilty.
                    Users are prohibited from reproducing or redistributing
                    platform elements without permission.
                  </p>
                  <h2>11. Limitation of Liability</h2>
                  <p>
                    To the fullest extent permitted by law, MyBilty and its
                    operators shall not be liable for any indirect, incidental,
                    or consequential damages, including lost profits, arising
                    from the use or inability to use the platform.
                  </p>
                  <h2>12. Indemnification</h2>
                  <p>
                    You agree to indemnify and hold MyBilty harmless from any
                    claims, losses, damages, or expenses arising from your
                    violation of these Terms or misuse of the platform.
                  </p>
                  <h2>13. Governing Law and Jurisdiction</h2>
                  <p>
                    These Terms are governed by the laws of India. Disputes
                    shall be subject to the jurisdiction of courts in Rajasthan.
                  </p>
                  <h2>14. Amendments to Terms</h2>
                  <p>
                    We reserve the right to update these Terms at any time.
                    Continued use of the platform constitutes acceptance of
                    updated Terms.
                  </p>
                  <h2>15. Contact Information</h2>
                  <p>If you have any queries, please contact us:</p>
                  <p>
                    Email:{" "}
                    <a href="mailto:support@dizixpert.com">
                      support@dizixpert.com
                    </a>
                    <br />
                    Phone: +91 9351111477
                    <br />
                    Address: Dizixpert Techno Services Pvt. Ltd., Sri Ganganagar
                    Road, Jaipur Jodhpur By-Pass, Bikaner (Raj.) - 334001
                  </p>
                  <h2>16. Acknowledgement</h2>
                  <p>
                    By using the MyBilty platform, you acknowledge that you have
                    read, understood, and agreed to these Terms and Conditions.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </>
      </Layout>
    </>
  );
}
